export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有韩漫作品，发现您的下一个心头好' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的韩漫恋爱故事，心动不止一刻' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '穿越异世界，开启奇幻冒险之旅' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作韩漫，拳拳到肉的畅快体验' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理，层层揭开真相' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的韩漫日常，笑到停不下来' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-line', description: '深度剧情韩漫，引人入胜的故事世界' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚恐怖韩漫，挑战你的胆量极限' },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-sun-line', description: '温暖治愈的日常生活，平平淡淡才是真' },
];

export const comics = [
  {
    id: 1,
    title: '重生之都市仙尊',
    author: '金明洙',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20genre%2C%20male%20protagonist%20with%20dark%20hair%20in%20modern%20urban%20setting%2C%20mystical%20energy%20surrounding%20him%2C%20dramatic%20lighting%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20professional%20manhwa%20art&width=280&height=360&seq=comic-01&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20genre%2C%20male%20protagonist%20with%20dark%20hair%20in%20modern%20urban%20setting%2C%20mystical%20energy%20surrounding%20him%2C%20dramatic%20lighting%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20professional%20manhwa%20art&width=320&height=420&seq=comic-01-lg&orientation=portrait',
    description: '一代仙尊渡劫失败，重生回到都市少年时代。这一世，他要弥补所有遗憾，让那些曾经伤害过他的人付出代价！',
    rating: 9.5,
    views: 1280000,
    chapters: 156,
    status: '连载中',
    tags: ['重生', '修仙', '都市', '爽文'],
    updatedAt: '2026-08-04',
  },
  {
    id: 2,
    title: '霸道总裁的契约新娘',
    author: '李恩智',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20genre%2C%20elegant%20female%20lead%20in%20luxurious%20dress%2C%20handsome%20male%20lead%20in%20suit%2C%20romantic%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20soft%20warm%20lighting%2C%20clean%20background%20with%20subtle%20floral%20elements&width=280&height=360&seq=comic-02&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20genre%2C%20elegant%20female%20lead%20in%20luxurious%20dress%2C%20handsome%20male%20lead%20in%20suit%2C%20romantic%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20soft%20warm%20lighting%2C%20clean%20background%20with%20subtle%20floral%20elements&width=320&height=420&seq=comic-02-lg&orientation=portrait',
    description: '为了拯救家族企业，她不得不嫁给冷酷的霸道总裁。原以为只是一场交易婚姻，却没想到他早已暗恋她多年...',
    rating: 9.3,
    views: 2150000,
    chapters: 89,
    status: '连载中',
    tags: ['总裁', '契约婚姻', '甜宠', '逆袭'],
    updatedAt: '2026-08-05',
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20thriller%20genre%2C%20detective%20protagonist%20in%20dark%20alley%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20dramatic%20shadows%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background%20with%20dark%20gradient&width=280&height=360&seq=comic-03&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20thriller%20genre%2C%20detective%20protagonist%20in%20dark%20alley%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20dramatic%20shadows%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background%20with%20dark%20gradient&width=320&height=420&seq=comic-03-lg&orientation=portrait',
    description: '一个连环杀手在城市中肆虐，天才侦探必须在一个月内找到真相，否则下一个受害者就是他自己。',
    rating: 9.7,
    views: 980000,
    chapters: 67,
    status: '连载中',
    tags: ['悬疑', '侦探', '犯罪', '心理'],
    updatedAt: '2026-08-03',
  },
  {
    id: 4,
    title: '我的室友是九尾狐',
    author: '崔秀英',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20romance%20genre%2C%20beautiful%20female%20nine-tailed%20fox%20spirit%2C%20modern%20apartment%20setting%2C%20magical%20elements%2C%20warm%20and%20whimsical%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background&width=280&height=360&seq=comic-04&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20romance%20genre%2C%20beautiful%20female%20nine-tailed%20fox%20spirit%2C%20modern%20apartment%20setting%2C%20magical%20elements%2C%20warm%20and%20whimsical%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background&width=320&height=420&seq=comic-04-lg&orientation=portrait',
    description: '普通大学生意外与一只修炼千年的九尾狐成为室友，从此生活变得奇幻又搞笑！',
    rating: 9.4,
    views: 1850000,
    chapters: 120,
    status: '连载中',
    tags: ['九尾狐', '奇幻', '恋爱', '搞笑'],
    updatedAt: '2026-08-05',
  },
  {
    id: 5,
    title: '拳皇之路',
    author: '郑大贤',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20genre%2C%20muscular%20fighter%20protagonist%20in%20boxing%20ring%2C%20dynamic%20pose%2C%20intense%20atmosphere%2C%20sweat%20and%20impact%20effects%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=280&height=360&seq=comic-05&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20genre%2C%20muscular%20fighter%20protagonist%20in%20boxing%20ring%2C%20dynamic%20pose%2C%20intense%20atmosphere%2C%20sweat%20and%20impact%20effects%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=320&height=420&seq=comic-05-lg&orientation=portrait',
    description: '一个街头混混凭借一双铁拳，从地下拳场打到世界冠军的传奇之路！',
    rating: 9.2,
    views: 1560000,
    chapters: 203,
    status: '连载中',
    tags: ['格斗', '热血', '竞技', '成长'],
    updatedAt: '2026-08-04',
  },
  {
    id: 6,
    title: '校园爆笑日记',
    author: '韩智敏',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20comedy%20genre%2C%20funny%20high%20school%20students%2C%20exaggerated%20expressions%2C%20bright%20colorful%20atmosphere%2C%20humorous%20scene%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20white%20background&width=280&height=360&seq=comic-06&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20comedy%20genre%2C%20funny%20high%20school%20students%2C%20exaggerated%20expressions%2C%20bright%20colorful%20atmosphere%2C%20humorous%20scene%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20white%20background&width=320&height=420&seq=comic-06-lg&orientation=portrait',
    description: '一群高中好友的爆笑日常，每一页都能让你笑到肚子疼！',
    rating: 9.1,
    views: 2100000,
    chapters: 178,
    status: '连载中',
    tags: ['搞笑', '校园', '日常', '友情'],
    updatedAt: '2026-08-03',
  },
  {
    id: 7,
    title: '深渊之花',
    author: '尹素熙',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20melancholic%20female%20protagonist%2C%20emotional%20atmosphere%2C%20rainy%20cityscape%20background%2C%20poetic%20and%20deep%20mood%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20muted%20color%20palette&width=280&height=360&seq=comic-07&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20melancholic%20female%20protagonist%2C%20emotional%20atmosphere%2C%20rainy%20cityscape%20background%2C%20poetic%20and%20deep%20mood%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20muted%20color%20palette&width=320&height=420&seq=comic-07-lg&orientation=portrait',
    description: '在深渊般绝望的人生中，一朵希望之花悄然绽放。这是关于救赎与被救赎的动人故事。',
    rating: 9.8,
    views: 890000,
    chapters: 45,
    status: '连载中',
    tags: ['剧情', '治愈', '成长', '人生'],
    updatedAt: '2026-08-02',
  },
  {
    id: 8,
    title: '午夜诊所',
    author: '金俊秀',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20horror%20genre%2C%20eerie%20medical%20clinic%20at%20night%2C%20mysterious%20doctor%20figure%2C%20dark%20and%20creepy%20atmosphere%2C%20cold%20blue%20lighting%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=280&height=360&seq=comic-08&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20horror%20genre%2C%20eerie%20medical%20clinic%20at%20night%2C%20mysterious%20doctor%20figure%2C%20dark%20and%20creepy%20atmosphere%2C%20cold%20blue%20lighting%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=320&height=420&seq=comic-08-lg&orientation=portrait',
    description: '只在午夜营业的神秘诊所，每个走进来的人都带着不为人知的秘密，而有人的秘密关乎生死...',
    rating: 9.6,
    views: 750000,
    chapters: 34,
    status: '连载中',
    tags: ['恐怖', '惊悚', '医疗', '悬疑'],
    updatedAt: '2026-08-01',
  },
  {
    id: 9,
    title: '咖啡与猫的午后',
    author: '张美妍',
    category: 'slice-of-life',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20slice%20of%20life%20genre%2C%20cozy%20cafe%20with%20cats%2C%20warm%20sunlight%2C%20peaceful%20atmosphere%2C%20cute%20illustration%20style%2C%20webtoon%20style%2C%20vertical%20composition%2C%20clean%20warm%20background&width=280&height=360&seq=comic-09&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20slice%20of%20life%20genre%2C%20cozy%20cafe%20with%20cats%2C%20warm%20sunlight%2C%20peaceful%20atmosphere%2C%20cute%20illustration%20style%2C%20webtoon%20style%2C%20vertical%20composition%2C%20clean%20warm%20background&width=320&height=420&seq=comic-09-lg&orientation=portrait',
    description: '一家隐藏在小巷里的猫咪咖啡馆，每天都有不同的客人带着各自的故事走进来。',
    rating: 9.3,
    views: 670000,
    chapters: 92,
    status: '连载中',
    tags: ['日常', '治愈', '猫咪', '咖啡'],
    updatedAt: '2026-08-04',
  },
  {
    id: 10,
    title: '废柴逆袭系统',
    author: '柳泰浩',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20genre%2C%20ordinary%20student%20with%20game-like%20interface%20overlay%2C%20dynamic%20action%20pose%2C%20bright%20energy%20effects%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background&width=280&height=360&seq=comic-10&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20genre%2C%20ordinary%20student%20with%20game-like%20interface%20overlay%2C%20dynamic%20action%20pose%2C%20bright%20energy%20effects%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background&width=320&height=420&seq=comic-10-lg&orientation=portrait',
    description: '平庸高中生意外获得逆袭系统，从此人生犹如开挂，打脸一切看不起他的人！',
    rating: 9.4,
    views: 2340000,
    chapters: 245,
    status: '连载中',
    tags: ['系统', '逆袭', '爽文', '校园'],
    updatedAt: '2026-08-05',
  },
  {
    id: 11,
    title: '她的秘密花园',
    author: '孙艺珍',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20genre%2C%20beautiful%20florist%20female%20lead%20surrounded%20by%20flowers%2C%20spring%20atmosphere%2C%20soft%20pastel%20colors%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background%20with%20floral%20elements&width=280&height=360&seq=comic-11&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20genre%2C%20beautiful%20florist%20female%20lead%20surrounded%20by%20flowers%2C%20spring%20atmosphere%2C%20soft%20pastel%20colors%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20background%20with%20floral%20elements&width=320&height=420&seq=comic-11-lg&orientation=portrait',
    description: '花艺师的她拥有与植物沟通的能力，直到某天遇到了完全不受她能力影响的那个男人...',
    rating: 9.5,
    views: 1450000,
    chapters: 78,
    status: '连载中',
    tags: ['恋爱', '奇幻', '花艺', '治愈'],
    updatedAt: '2026-08-04',
  },
  {
    id: 12,
    title: '代号：猎鹰',
    author: '权相佑',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20genre%2C%20special%20agent%20in%20tactical%20gear%2C%20intense%20mission%20scene%2C%20explosive%20background%2C%20cinematic%20composition%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=280&height=360&seq=comic-12&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20genre%2C%20special%20agent%20in%20tactical%20gear%2C%20intense%20mission%20scene%2C%20explosive%20background%2C%20cinematic%20composition%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=320&height=420&seq=comic-12-lg&orientation=portrait',
    description: '退役特种兵被卷入一场国际阴谋，他必须重拾战斗本能，在敌我难辨的战场上杀出一条血路。',
    rating: 9.6,
    views: 1120000,
    chapters: 56,
    status: '连载中',
    tags: ['特工', '军事', '动作', '阴谋'],
    updatedAt: '2026-08-03',
  },
  {
    id: 13,
    title: '我的ID是江南美人',
    author: '朴敏英',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20beautiful%20female%20college%20student%2C%20campus%20setting%2C%20emotional%20story%20about%20beauty%20standards%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20soft%20background&width=280&height=360&seq=comic-13&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20beautiful%20female%20college%20student%2C%20campus%20setting%2C%20emotional%20story%20about%20beauty%20standards%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20soft%20background&width=320&height=420&seq=comic-13-lg&orientation=portrait',
    description: '因外貌被欺凌的女孩通过整容变成美女进入大学，却发现美貌带来的世界远比想象中复杂。',
    rating: 9.7,
    views: 3200000,
    chapters: 134,
    status: '已完结',
    tags: ['校园', '整容', '成长', '爱情'],
    updatedAt: '2026-07-20',
  },
  {
    id: 14,
    title: '鬼怪杂货铺',
    author: '全智贤',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20horror%20fantasy%20genre%2C%20mysterious%20antique%20shop%2C%20ghostly%20atmosphere%2C%20dim%20warm%20lighting%2C%20supernatural%20elements%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=280&height=360&seq=comic-14&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20horror%20fantasy%20genre%2C%20mysterious%20antique%20shop%2C%20ghostly%20atmosphere%2C%20dim%20warm%20lighting%2C%20supernatural%20elements%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=320&height=420&seq=comic-14-lg&orientation=portrait',
    description: '一家只在深夜营业的杂货铺，每件商品都附着一个鬼魂的故事。你敢来逛逛吗？',
    rating: 9.2,
    views: 580000,
    chapters: 42,
    status: '连载中',
    tags: ['恐怖', '奇幻', '单元剧', '鬼怪'],
    updatedAt: '2026-08-02',
  },
  {
    id: 15,
    title: '顶级流量的秘密',
    author: '金泰亨',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20handsome%20male%20idol%20on%20stage%2C%20spotlight%20and%20crowd%2C%20glamorous%20but%20melancholic%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=280&height=360&seq=comic-15&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20drama%20genre%2C%20handsome%20male%20idol%20on%20stage%2C%20spotlight%20and%20crowd%2C%20glamorous%20but%20melancholic%20atmosphere%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20dark%20background&width=320&height=420&seq=comic-15-lg&orientation=portrait',
    description: '表面光鲜的顶流偶像，背地里却隐藏着令人心碎的秘密。当真相被揭开的那一天...',
    rating: 9.5,
    views: 2780000,
    chapters: 98,
    status: '连载中',
    tags: ['娱乐圈', '偶像', '剧情', '悬疑'],
    updatedAt: '2026-08-05',
  },
  {
    id: 16,
    title: '独行月球',
    author: '宋仲基',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20comedy%20sci-fi%20genre%2C%20lonely%20astronaut%20on%20moon%20surface%2C%20humorous%20expression%2C%20earth%20in%20background%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20space%20background&width=280&height=360&seq=comic-16&orientation=portrait',
    coverImageLarge: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20comedy%20sci-fi%20genre%2C%20lonely%20astronaut%20on%20moon%20surface%2C%20humorous%20expression%2C%20earth%20in%20background%2C%20webtoon%20style%20illustration%2C%20vertical%20composition%2C%20clean%20space%20background&width=320&height=420&seq=comic-16-lg&orientation=portrait',
    description: '被意外遗留在月球上的宇航员，开启了一段爆笑又孤独的月球生存之旅！',
    rating: 9.4,
    views: 1890000,
    chapters: 67,
    status: '已完结',
    tags: ['搞笑', '科幻', '生存', '治愈'],
    updatedAt: '2026-07-15',
  },
];